module.exports = __webpack_public_path__ + "img/6eecd8ef27414ea06a905c293ef1df4.39b44a68.jpg";